import gameIds from 'a/hub/data/GameIds';

// replace "NEW_GAME" with your gameId
export const GAME_ID = gameIds.PICKY_GOBLINS;

export const NUM_CORRECT_PRACTICE_ITEMS = 4;
export const NUM_INCORRECT_PRACTICE_ITEMS = 2;

// Help identifier not level selected.
export const HELP_LEVEL_ID = -1;

// Game screens
export const SCREENS = {
  PROGRESS: 'PROGRESS',
  ONBOARDING: 'ONBOARDING',
  REPEAT_ONBOARDING: 'REPEAT_ONBOARDING', // for accessing onboarding through the progress screen
  LEVEL_INTRO: 'LEVEL_INTRO',
  STANDARD_VIEW: 'STANDARD_VIEW',
  LOADING: 'LOADING',
  PRACTICE: 'PRACTICE',
};

export const QUESTIONTYPE = {
  ONBOARDING: 'ONBOARDING',
  STANDARD: 'STANDARD',
  PRACTICE: 'PRACTICE',
};

export const REDUX_ACTIONS = {
  CHANGE_SCREEN: 'CHANGE_SCREEN',
  INCREMENT_PROGRESS: 'INCREMENT_PROGRESS',
  RESET_CORRECT_ANSWER: 'RESET_CORRECT_ANSWER',
  INCREMENT_CORRECT_ANSWER: 'INCREMENT_CORRECT_ANSWER',
  DEV_SET_ALL_ANSWERS_CORRECT: 'DEV_SET_ALL_ANSWERS_CORRECT',
  SET_PROGRESS: 'SET_PROGRESS',
  START_LEVEL: 'START_LEVEL',
  INCREMENT_LEVEL_HIGHLIGHT: 'INCREMENT_LEVEL_HIGHLIGHT',
  DEV_INCREMENT_LEVEL_HIGHLIGHT_ALL: 'DEV_INCREMENT_LEVEL_HIGHLIGHT_ALL',
  UPDATE_PRACTICE_ROUND: 'UPDATE_PRACTICE_ROUND',
  REGISTER_ONBOARDING_PRACTICE_COMPLETE: 'REGISTER_ONBOARDING_PRACTICE_COMPLETE',
  REGISTER_ONBOARDING_QUEST_COMPLETE: 'REGISTER_ONBOARDING_QUEST_COMPLETE',
  REGISTER_VIEW: 'REGISTER_VIEW',
  SAVE_SCREEN_COORDINATES: 'SAVE_SCREEN_COORDINATES',
  UPDATE_DRAGGING_ITEM: 'UPDATE_DRAGGING_ITEM',
  SET_LIP_BUTTON_DISABLED: 'SET_LIP_BUTTON_DISABLED',
  PRACTICE_UPDATE_CARDS_DRAGGABLE: 'PRACTICE_UPDATE_CARDS_DRAGGABLE',
  PRACTICE_UPDATE_WORD_TO_HIGHLIGHT: 'PRACTICE_UPDATE_WORD_TO_HIGHLIGHT',
  PRACTICE_UPDATE_WORD_TO_SHAKE: 'PRACTICE_UPDATE_WORD_TO_SHAKE',
  PRACTICE_ADD_ANSWER: 'PRACTICE_ADD_ANSWER',
  PRACTICE_RESET: 'PRACTICE_RESET',
  PROJECTOR_SET_ANIMATION: 'PROJECTOR_SET_ANIMATION',
  PROJECTOR_PLAYLIPS: 'PROJECTOR_PLAYLIPS',
  PROJECTOR_SET_TARGET_LETTER: 'PROJECTOR_SET_TARGET_LETTER',
  GOBLIN_SET_ANIMATION: 'GOBLIN_SET_ANIMATION',
  GOBLIN_SET_DISABLED: 'GOBLIN_SET_DISABLED',
  TOAST_SET_STATUS: 'TOAST_SET_STATUS',
};

export const GOBLIN_ANIMATIONS = {
  IDLE: 'IDLE',
  SPIT: 'SPIT',
  EATING: 'EATING',
  TALKING: 'TALKING',
  HANGRY: 'HANGRY',
  WRONG_TRANSITION: 'WRONG_TRANSITION',
};

export const GOBLIN_FRAMES = {
  [GOBLIN_ANIMATIONS.IDLE]: [28, 89],
  [GOBLIN_ANIMATIONS.SPIT]: [90, 119],
  [GOBLIN_ANIMATIONS.EATING]: [120, 179],
  [GOBLIN_ANIMATIONS.TALKING]: [0, 27],
  [GOBLIN_ANIMATIONS.WRONG_TRANSITION]: [180, 199],
  [GOBLIN_ANIMATIONS.HANGRY]: [200, 218],
};

export const OPACITY_VALUES = [0, 0, 0.3, 1];

export const PROJECTOR_ANIMATIONS = {
  OPEN: 'OPEN',
  CLOSE: 'CLOSE',
};

export const PROJECTOR_LENGTHS = {
  SHORT_PROJECTOR: -170,
  LONG_PROJECTOR: 0,
};

export const LETTERS_VALIDATE_CONTAIN = [
  'r (medial)',
  'rr',
  'y (final)',
  'x',
];

export const MOUTH_FRAMES = {
  A: [0, 47],
  B: [48, 86],
  C: [87, 126],
  CH: [87, 126],
  'C (S)': [87, 126],
  'C (CA, CO, CU)': [87, 126], // spanish  letter
  D: [876, 911],
  E: [126, 168],
  F: [169, 209],
  G: [87, 126],
  'G (GUE/GUI)': [87, 126], // spanish  letter
  'G (A, O, U)': [87, 126], // spanish  letter
  'G (E, I)': [87, 126], // spanish  letter
  H: [209, 252],
  I: [253, 298],
  J: [299, 336],
  K: [87, 126],
  L: [337, 379],
  LL: [337, 379],
  M: [380, 444],
  N: [445, 493],
  Ñ: [445, 493],
  O: [494, 548],
  P: [48, 86],
  Q: [549, 593],
  'Q (K)': [549, 593], // spanish letter
  R: [594, 639],
  RR: [594, 639],
  'R (MEDIAL)': [594, 639], // spanish letter
  S: [640, 692],
  T: [876, 911],
  U: [549, 593],
  V: [169, 209],
  W: [737, 780],
  X: [781, 833],
  Y: [834, 875],
  'Y (FINAL)': [834, 875],
  Z: [640, 692],
};

export const TOAST_STATUSES = {
  DISABLED: 'DISABLED', // Toast cannot be interacted with.
  ONLY_CLICKABLE: 'ONLY_CLICKABLE', // clickable with keyboard controls or mouse
  DRAGGABLE: 'DRAGGABLE', // Toast is draggable. only clickable with space or enter for keyboard controls
};

export const MOUSE_EVENTS = {
  MOUSEDOWN: 'mousedown',
  MOUSEUP: 'mouseup',
};

// Inits default declaration of function.
export const INIT_FUNCTION = () => {};
